import { Action, ActionType } from "../actions";

interface TpoErrorState {
    error: string | null;
}

const initialState: TpoErrorState = { error: null };

const tpoErrorReducer = (
    state: TpoErrorState = initialState,
    action: Action
): TpoErrorState => {
    switch (action.type) {
        case ActionType.TPO_VALIDATION_ERROR:
            return { error: action.payload };
        default:
            return state;
    }
};

export default tpoErrorReducer;